export const availableParams = [
  "page",
  "merchant_id",
  "category_id",
  "region_id",
  "regions",
  "cities",
  "published",
  "is_featured",
  "city",
  "sort",
  "q",
  "show_stat"
];



// WEBPACK FOOTER //
// ./src/core/helper.js